import { ONBOARDING_CONFIG } from '../features/onboarding/constants';
import { useStores } from '../stores/useStores';

export function useSideMenu() {
  const { onboardingStore, uiStore } = useStores();

  const handleClose = () => {
    if (ONBOARDING_CONFIG.MENU_ACTIONS.has(onboardingStore.step)) {
      return null;
    }
    uiStore.setSideMenuOpen(false);
  };

  const handleToggle = () => {
    uiStore.setSideMenuOpen(!uiStore.sideMenuOpen);
  };

  return {
    handleClose,
    handleToggle,
  };
}
